// extracted by mini-css-extract-plugin
module.exports = {"footerText":"FooterLogin_footerText__Zhcbk"};